import { Badge } from '@/components/ui/badge'
import { IS_DEV } from '@/lib/constant'

interface DraftBadgeProps {
  draft?: boolean
  className?: string
}

export function DraftBadge({ draft, className = '' }: DraftBadgeProps) {
  // Only show in development environment and when draft is true
  if (!IS_DEV || !draft) {
    return null
  }

  return (
    <Badge
      variant="outline"
      className={`text-xs px-2 py-1 rounded-full font-semibold bg-gold/20 text-gold border-gold/50 ${className}`}
    >
      DRAFT
    </Badge>
  )
}
